module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/plans-detail-dialog-icon1-30bf852c881b6ef929f6c9639713ed31.png";